import type { AccordionData } from "@/design-system/Molecules/AccordionList/Accordion.types";
import React from "react";

const qaPairs: [string, React.ReactNode][] = [
  [
    "Papaverine",
    <>
      Papaverine expands blood vessels to encourage blood flow for healthy erections.
    </>,
  ],
  [
    "Phentolamine",
    <>
      Phentolamine also increases blood flow, which is crucial for achieving an erection.
    </>,
  ],
  [
    "Prostaglandin",
    <>
      Prostaglandin relaxes the smooth muscle and dilates the blood vessels.
    </>,
  ],
];
export const ingredientsData: AccordionData[] = qaPairs.map(
  ([question, answer]) => ({
    question,
    answer
  })
);